import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { PortRequestFormServiceService } from '../../service/port-request-FormService/port-request-form.service.service';

@Component({
  selector: 'app-export-file-popup',
  templateUrl: './export-file-popup.component.html',
  styleUrls: ['./export-file-popup.component.scss']
})
export class ExportFilePopupComponent {
  reportTypeForm: FormGroup;
  isLoading = false;

  // 🔥 dynamic IMO and vessel name from parent
  imoNumber!: string;
  vesselName!: string;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ExportFilePopupComponent>,
    private prequestFormService: PortRequestFormServiceService,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.reportTypeForm = this.fb.group({
      reportType: ['', Validators.required]
    });

    // ✅ dynamic data assign with fallback to localStorage
    this.imoNumber =
      data?.imoNumber ||
      localStorage.getItem('pImo') ||
      localStorage.getItem('vesselImo') ||
      '';

    this.vesselName =
      data?.vesselName ||
      localStorage.getItem('pShipName') ||
      '';
  }

  private normalizeImo(value: unknown): string | null {
    const cleaned = String(value ?? '')
      .trim()
      .replace(/[^0-9]/g, '');

    return cleaned.length ? cleaned : null;
  }

  onSubmit(): void {
    const normalizedImo = this.normalizeImo(this.imoNumber);

    if (!normalizedImo) {
      this.toastr.warning('Vessel IMO is missing. Unable to download report.');
      return;
    }

    if (this.reportTypeForm.invalid) return;

    this.imoNumber = normalizedImo;

    const selectedReport = this.reportTypeForm.value.reportType;

    const sourceMap: any = {
      portConsumption: 'PC',
      speedConsumption: 'SNC',
      combinedReport: undefined
    };

    const sourceParam = sourceMap[selectedReport];

    this.isLoading = true;

    this.prequestFormService
      .getCombinedReportData(this.imoNumber, sourceParam, this.vesselName)
      .subscribe({
        next: (res: Blob) => {
          this.isLoading = false;

          // 🔥 DOWNLOAD FILE
          const blob = new Blob([res], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });

          const url = window.URL.createObjectURL(blob);

          const a = document.createElement('a');
          a.href = url;

          // 🔥 dynamic filename
          a.download = `${selectedReport}_${this.imoNumber}_report.xlsx`;

          document.body.appendChild(a);
          a.click();

          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);

          this.toastr.success('Report downloaded successfully');
          this.dialogRef.close({ downloaded: true });
        },

        error: (err: any) => {
          console.error('API Error:', err);
          this.isLoading = false;
          this.toastr.error('Failed to download report. Please try again.');
        }
      });
  }

  closeModal() {
    this.dialogRef.close();
  }
}